import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(3px);
  }
`;

// 독립형 (구분선 자체를 그리는 버전 — 회원권 등 border 없는 곳)
const StandaloneContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginTop: '16px',
});

const Line = styled(Box)({
  flex: 1,
  height: '1px',
  backgroundColor: '#e1e1e1',
});

// 보더 하단 겹침형 (박스 border 하단 중앙에 걸치는 버전)
const BorderOverlayContainer = styled(Box)({
  position: 'absolute',
  bottom: '-14px',
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
});

const ToggleButton = styled(Button)({
  color: '#555',
  fontSize: '13px',
  fontWeight: 600,
  textTransform: 'none',
  padding: '2px 16px',
  whiteSpace: 'nowrap',
  borderRadius: '20px',
  backgroundColor: '#fff',
  zIndex: 1,
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});

const AnimatedIcon = styled(KeyboardDoubleArrowDownIcon, {
  shouldForwardProp: prop => prop !== 'open',
})(({ open }) => ({
  fontSize: '20px',
  color: '#888',
  transition: 'transform 0.3s ease',
  transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  ...(!open && {
    animation: `${bounce} 1.5s ease-in-out infinite`,
  }),
}));

const CommonFilterToggle = ({ open, onClick, variant = 'standalone' }) => {
  if (variant === 'border') {
    return (
      <BorderOverlayContainer>
        <ToggleButton size="small" onClick={onClick} endIcon={<AnimatedIcon open={open} />}>
          {open ? '상세 필터 접기' : '상세 필터 펼치기'}
        </ToggleButton>
      </BorderOverlayContainer>
    );
  }

  return (
    <StandaloneContainer>
      <Line />
      <ToggleButton size="small" onClick={onClick} endIcon={<AnimatedIcon open={open} />}>
        {open ? '상세 필터 접기' : '상세 필터 펼치기'}
      </ToggleButton>
      <Line />
    </StandaloneContainer>
  );
};

export default CommonFilterToggle;
